import apolloClient from "../apolloClient";
import { GET_EVENTS, GET_EVENT, GET_EVENT_SLOTS } from "./graphql";

class EventService {
	async list() {
		const response = await apolloClient.query({
			query: GET_EVENTS,
		});
		return response.data.events.nodes;
	}

	async get(eventId) {
		const response = await apolloClient.query({
			query: GET_EVENT,
			variables: { id: eventId },
		});
		return response.data.event;
	}

	async getEventSlots(eventId) {
		const response = await apolloClient.query({
			query: GET_EVENT_SLOTS,
			variables: { eventId },
		});
		return response.data.eventSlots.nodes;
	}
}

export default new EventService();
